export enum VariantType {
	RADIO = "RADIO",
	IMAGE_PER_ITEM = "IMAGE_PER_ITEM",
	CURSOR = "CURSOR",
	DROPDOWN = "DROPDOWN",
}
